import axios from "axios";
import config from "../config/config";


const USERNAME = import.meta.env.VITE_API_USERNAME;
const PASSWORD = import.meta.env.VITE_API_PASSWORD;

const AUTH_HEADER = "Basic " + btoa(`${USERNAME}:${PASSWORD}`);

export async function fetchGoldData() {
  const authHeader = config.getAuthHeader();
  if (!authHeader) return { error: "Authentication credentials not available" };
  const isUrl = config.buildApiUrl("scrab");
  try {
    const response = await axios.get(isUrl, {  // Use config URL instead of hardcoded
      headers: { Authorization: AUTH_HEADER },
    });
    return response.data;
  } catch (err) {
    console.error("Failed to fetch gold data:", err.response?.status, err.response?.data || err.message);
    return { error: err.response?.data || err.message };
  }
}

// --- Update gold prices ---
export async function updateGoldPrices(payload) {
  const authHeader = config.getAuthHeader();
  if (!authHeader) return { error: "Authentication credentials not available" };

  try {
    const response = await axios.post(config.buildApiUrl("updatePrice"), payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: authHeader,
      },
    });
    return response.data;
  } catch (err) {
    console.error("Failed to update gold prices:", err.response?.status, err.response?.data || err.message);
    return { error: err.response?.data || err.message };
  }
}

// --- Refetch gold data (cron) ---
export async function refetchGoldData() {
  const authHeader = config.getAuthHeader();
  if (!authHeader) return { error: "Authentication credentials not available" };

  try {
    const response = await axios.get(config.buildApiUrl("cron"), {
      headers: { Authorization: authHeader },
    });
    return response.data;
  } catch (err) {
    console.error("Failed to refetch gold data:", err.response?.status, err.response?.data || err.message);
    return { error: err.response?.data || err.message };
  }
}
